<template>
  <div ref="containerRef" class="timeline-container">

    <!-- FLORES DECORATIVAS -->
    <img src="@/assets/moñii.png" class="flor flor-left" alt="flor izquierda" />

    <div class="carousel-wrapper">
      
      <!-- Flechas -->
      <button
        class="carousel-button left"
        @click="prevSlide"
        v-if="currentIndex > 0"
        aria-label="Anterior"
      >‹</button>
      <button
        class="carousel-button right"
        @click="nextSlide"
        v-if="currentIndex < hotels.length - 1"
        aria-label="Siguiente"
      >›</button>

      <div class="carousel" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div
          v-for="(hotel, index) in hotels"
          :key="index"
          class="hotel-card"
          :ref="el => setHotelCard(el, index)"
        >
          <p class="recomendacion-hospedaje" :ref="el => setRefs(el, index, 'titulo')">{{ hotel.titulo }}</p>
          <p :ref="el => setRefs(el, index, 'descripcion')">{{ hotel.descripcion }}</p>
          <img
            :src="hotel.imagen"
            :alt="hotel.nombre"
            class="hotel-image rounded-circle"
            :ref="el => setRefs(el, index, 'imagen')"
          />
          <div class="hotel-info" :ref="el => setRefs(el, index, 'info')">
            <h3>{{ hotel.nombre }}</h3><br>
            <strong>Dirección:</strong><br />
            <p v-html="hotel.direccion"></p>
            <p><i class="fas fa-phone" /> {{ hotel.telefono }}</p>
            <a
              :href="hotel.ubicacion"
              class="modern-button"
              target="_blank"
              rel="noopener noreferrer"
              :ref="el => setRefs(el, index, 'boton')"
            >
              Ubicación <i class="fas fa-map-marker-alt" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import { gsap } from 'gsap';

import hotel1Img from '@/assets/hotel1.webp';

export default {
  name: 'HospedajeVue',
  setup() {
    const containerRef = ref(null);
    const hotelCards = ref([]);
    const refsMap = ref([]);
    const currentIndex = ref(0);

    const hotels = [
      {
        titulo: 'Hospedaje.',
        descripcion: 'Recomendación.',
        nombre: 'La Quinta Inn & Suites by Wyndham San Antonio',
        imagen: hotel1Img,
        direccion: '7502 Northwest Loop 410, San Antonio, TX 78245, Estados Unidos',
        telefono: '+1 210 549 54 24 ',
        ubicacion: 'https://maps.app.goo.gl/iqMtQTk4M7KkZ21K8'
      },
      
    ];

    const setHotelCard = (el, index) => {
      if (el) hotelCards.value[index] = el;
    };

    const setRefs = (el, index, key) => {
      if (!refsMap.value[index]) refsMap.value[index] = {};
      refsMap.value[index][key] = el;
    };

    const animateElements = (elements) => {
      if (!elements) return;
      gsap.fromTo(elements.titulo, { x: -50, opacity: 0 }, { x: 0, opacity: 1, duration: 0.6 });
      gsap.fromTo(elements.descripcion, { opacity: 0, scale: 0.9 }, { opacity: 1, scale: 1, duration: 0.6, delay: 0.2 });
      gsap.fromTo(elements.imagen, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, delay: 0.4 });
      gsap.fromTo(elements.info, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.6, delay: 0.6 });
      gsap.fromTo(elements.boton, { scale: 0.8, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.6, delay: 0.8 });
    };

    const prevSlide = () => {
      if (currentIndex.value > 0) {
        currentIndex.value--;
        nextTick(() => animateElements(refsMap.value[currentIndex.value]));
      }
    };

    const nextSlide = () => {
      if (currentIndex.value < hotels.length - 1) {
        currentIndex.value++;
        nextTick(() => animateElements(refsMap.value[currentIndex.value]));
      }
    };

    onMounted(() => {
      const florLeft = document.querySelector('.flor-left');
      const florRight = document.querySelector('.flor-right');

      // animación de entrada flores
      gsap.fromTo([florLeft, florRight], 
        { autoAlpha: 0, scale: 0.85, y: 20 },
        { autoAlpha: 1, scale: 1, y: 0, duration: 1.2, ease: 'power3.out', delay: 0.1 }
      );

      // flotando suave
      gsap.to(florLeft, { y: '-=10', duration: 3, yoyo: true, repeat: -1, ease: 'sine.inOut' });
      gsap.to(florRight, { y: '+=10', duration: 3.2, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 0.2 });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = hotelCards.value.findIndex(el => el === entry.target);
            if (index !== -1) {
              animateElements(refsMap.value[index]);
              observer.unobserve(entry.target);
            }
          }
        });
      }, { threshold: 0.3 });

      hotelCards.value.forEach(card => card && observer.observe(card));
    });

    return { containerRef, hotelCards, hotels, currentIndex, prevSlide, nextSlide, setHotelCard, setRefs };
  }
};
</script>
<style scoped>
.timeline-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 95vh;
  position: relative;
  overflow: visible;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* FLORES DECORATIVAS */
.flor {
  position: absolute;
  width: min(42vw, 360px);
  z-index: 5;
  filter: drop-shadow(0px 4px 10px rgba(0,0,0,0.15));
  pointer-events: none;
  opacity: 0;
  margin-top:-90px;
  transform-origin: center;
}

.flor-left {
  left:10px !important;
  top: -420px;
  transform: rotate(-12deg);
}

.flor-right {
  right: -90px;
  bottom: 120px;
  transform: rotate(20deg);
}

.carousel-wrapper {
  position: relative;
  width: 80%;
  overflow: hidden;
}

.carousel {
  display: flex;
  transition: transform 0.6s ease;
}

.hotel-card {
  width: 100%;
  max-width: 500px;
  flex-shrink: 0;
  text-align: center;
  padding: 80px 20px;
  margin: 0 auto;
  border-radius: 0 80px 0 80px;
  background-color: #043b73;
;
  transition: transform 0.3s ease;
  box-shadow: 0 8px 20px rgba(0,0,0,0.16);
}

.hotel-card:hover {
  transform: scale(1.05);
}

.hotel-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 20px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .18);
}

.hotel-info {
  font-family: 'Josefin Sans', sans-serif;
  color: rgba(250, 250, 250, 0.9);
  line-height: 1.4;
}

.hotel-info h3 {
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
}

.hotel-card p {
  font-size: 16px;
  color: #ffffff;
}

.recomendacion-hospedaje {
  font-family: 'titulos';
  font-size: 66px !important;
  margin-bottom: 12px;
  color: #ffffffd7 !important;
}

.modern-button {
  display: inline-block;
  text-decoration: none;
  background: #ffffff;
  color: #333;
  padding: 8px 18px;
  font-family: 'padres';
  font-weight: bold;
  border: none;
  border-radius: 25px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, background 0.5s ease;
  margin-bottom: 15px;
}

.carousel-button {
  position: absolute;
  top: 50%;
  background: #f1efef;
  color: #333;
  width: 44px;
  height: 44px;
  font-size: 28px;
  font-family: 'Arial';
  font-weight: bold;
  z-index: 10;
  cursor: pointer;
  transform: translateY(-50%);
  transition: transform 0.3s ease, opacity 0.3s ease;
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-button.left {
  left: 10px;
  animation: moveLeft 1s infinite ease-in-out;
}

.carousel-button.right {
  right: 10px;
  animation: moveRight 1s infinite ease-in-out;
}

.carousel-button:hover {
  transform: scale(1.3) translateY(-50%);
  opacity: 1;
}

@keyframes moveLeft {
  0%, 100% { transform: translateX(0); opacity: 1; }
  50% { transform: translateX(-10px); opacity: 0.6; }
}

@keyframes moveRight {
  0%, 100% { transform: translateX(0); opacity: 1; }
  50% { transform: translateX(10px); opacity: 0.6; }
}

/* 📱 MÓVIL: flores más pequeñas y cercanas */
@media (max-width: 768px) {
  .flor {
    width: min(50vw, 150px);
  }

  .flor-left {
    left: -60px;
    top: 60px;
  }

  .flor-right {
    right: -60px;
    bottom: 60px;
  }
}
</style>
